import {upsert, setFetchingForView, setMetaProp, setView, setCurrent} from '../../../helpers'

export default {
  setFetchingForView,
  setView,
  setMetaProp,
  setCurrent,
  upsert
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/mutations.js